import { useEffect, useState } from "react";
import { Alert, Card, Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { getDiocesis, setOrgToken } from "../../controllers/org";
import { useAuth } from "../../components/auth/AuthProvider";
import ComunidadMembresíaGrafica from "../../components/comunidad/comunidadMembresiaGrafica";
import ComunidadMembresíaTabla from "../../components/comunidad/comunidadMembresiaTabla";
import Loading from "../../components/loading/Loading";
import CrearComunidad from "../../components/admin/CrearComunidad";
import ErrorAlert from "../../components/errors/ErrorAlert";
import Members from "./Members";
import ComunidadOrdenarLibros from "../../components/comunidad/comunidadOrdenarLibros";
import ComunidadOrderHistory from "../../components/comunidad/comunidadOrderHistory";

function Diocesis() {
  const params = useParams();
  const diocesisId = params.diocesisId;
  const [data, setData] = useState();
  const { token } = useAuth();
  const [errorCode, setErrorCode] = useState(); 
  setOrgToken(token);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (data) {
      document.title = `FAMA - Diócesis - ${data.diocesis.label}`;
    }
  }, [data]);

  async function loadData() {
    try {
      let d = await getDiocesis(diocesisId, 2025);
      console.log('diocesis', d);
      setData(d);
    }
    catch (e) {
      console.log(e);
      if (!isNaN(e.status)) {
        setErrorCode(e.status);
      }
    }
  }

  if (errorCode) {
    return <Container className='pt-5 pb-5'>
      <ErrorAlert code={errorCode} />
    </Container>;
  }
  if (!data) {
    return <Container className='pt-5 pb-5'>
      <Loading text="Cargando..." />
    </Container>;
  }

  let regionPath = `/app/org/regiones/${data.region.region_id}`;
  let regionLink = data.region.allowed ?
    <Link to={regionPath}>{data.region.label}</Link> :
    data.region.label;
  let nacionalPath = `/app/org/nacional/`;
    let nacionalLink = data.verMembresiaNacional ?
      <Link to={nacionalPath}>Nacional</Link> :
      'Nacional';

  
  function renderComunidades() {
    return <>
      <Card className="mb-3">
        <Card.Header>Comunidades</Card.Header>
        <Card.Body>
          {!!data.comunidades.length && data.comunidades.map(c => {
            return <p><Link to={'/app/org/comunidades/' + c.comunidad_id}>{c.label}</Link></p>
          })}
          {!data.comunidades.length && <Alert variant="warning">No hay comunidades en esta diócesis.</Alert>}
        </Card.Body>
      </Card>
      <CrearComunidad defaultRegion={data.region.region_id} defaultDiocesis={data.diocesis.diocesis_id} onSuccess={loadData} />
    </>;
  }

  let contenidoResumen;

  if (!data.members.members.count) {
    contenidoResumen = <Row>
      <Col md={6}>
        <Alert variant="warning">
          <p>No hay miembros en esta diócesis.</p>
        </Alert>
      </Col>
      <Col md={6}>
        {renderComunidades()}
      </Col>
    </Row>
  }
  else {
    contenidoResumen = <Row>
            <Col md={4}>
              <ComunidadMembresíaGrafica membresia={data.members.groups[0].diocesis[0].comunidades} title="Membresía Por Comunidad" />
            </Col>
            <Col md={4}>
              <ComunidadMembresíaTabla 
                membresia={data.members.groups[0].diocesis[0].comunidades} 
                total={{count: data.members.groups[0].diocesis[0].members_count, 
                paid: data.members.groups[0].diocesis[0].paid_members_count}} 
                title="Resumen de Membresía" 
                groupByLabel="Comunidades"
                link={true}
                />
            </Col>
            <Col md={4}>
              {renderComunidades()}
            </Col>
          </Row>;
  }

  return <Container className='pt-5 pb-5'>
      <h1>{data.diocesis.label}</h1>
      <Row>
        <Col>
          <p>{nacionalLink} / {regionLink}</p>
        </Col>
      </Row>
      <Tabs>
        <Tab eventKey="resumen" title="Resumen">
          {contenidoResumen}
        </Tab>
        <Tab eventKey="miembros" title="Miembros">
          <Members />
        </Tab>
        <Tab eventKey="libros" title="Ordenar Libros">
          <Row>
            <Col lg={8}><ComunidadOrdenarLibros 
              type="diocesis"
              comunidadId={params.comunidadId}
              matrimonioPresidente={data.members.members.rows.filter(u => u.membership_roles.find(mr => mr.role_id === 21))[0]}
            /></Col>
          </Row>
        </Tab>
        <Tab eventKey="order-history" title="Historial de órdenes" mountOnEnter={true} unmountOnExit={true}>
          <ComunidadOrderHistory type="diocesis" />
        </Tab>
      </Tabs>
  </Container>;
}

export default Diocesis;
